export default {
  namespaced: true,
  state     : {
    breadcrumbs: [
      {
        id      : 1,
        text    : 'Главная',
        link    : '/',
        disabled: false,
      },
      {
        id      : 2,
        text    : 'Банк идей',
        link    : '/ideas_bank',
        disabled: true,
      },
    ],
  },
  getters: {
    breadcrumbs: ({breadcrumbs}) => breadcrumbs,
  },
};

